export default "__VITE_ASSET__CPlhhEyj__"